import { ITreeItemResponse } from '@kcftech/prometheustypescriptapiclient';
import { sdClient } from 'contexts/SDKClientContext';
import { useBatchQuery } from 'custom_hooks/useBatchQuery';
import { useCallback } from 'react';
import { queryAll } from 'utils/query_v3';

const QueryBatchSize = 5;

export type LoadChildrenOptions = Readonly<{
    parentIds: string[];
    onSuccess: (parentId: string, children: ITreeItemResponse[]) => void;
    onError?: (parentId: string) => void;
}>;

export function useTreeItemDataLoader() {
    const { enqueue, queuedKeys: loadingIds } = useBatchQuery(QueryBatchSize);

    const loadChildren = useCallback(
        ({ parentIds, onSuccess, onError }: LoadChildrenOptions) => {
            enqueue<ITreeItemResponse[]>(
                parentIds.map((parentId) => ({
                    key: parentId,
                    query: () =>
                        queryAll((page) =>
                            sdClient.getTreeItemChildren({
                                treeItemId: parentId,
                                page,
                            })
                        ),
                    onSuccess: (children) => onSuccess(parentId, children),
                    onError: () => onError?.(parentId),
                }))
            );
        },
        [enqueue]
    );

    return {
        loadingIds,
        loadChildren,
    };
}
